// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-blacklist .ant-checkbox-group-item {\n  display: block;\n}\n.x-blacklist .x-blacklist-members {\n  height: 200px;\n  overflow-y: scroll;\n}\n.x-blacklist .x-blacklist-members .force-overflow {\n  min-height: 230px;\n}\n", ""]);
// Exports
module.exports = exports;
